webpackJsonp([212839066777427],{

/***/ 97:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  head: {
	    title: 'Blog',
	    meta: [{ name: 'description', content: 'This is a blog.' }],
	    links: [{ rel: 'canonical', href: 'https://youfoundron.com/blog' }]
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _blog = __webpack_require__(225);
	
	var _monthNames = __webpack_require__(76);
	
	var _monthNames2 = _interopRequireDefault(_monthNames);
	
	var _Head = __webpack_require__(55);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _Container = __webpack_require__(21);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _FadeInUp = __webpack_require__(27);
	
	var _FadeInUp2 = _interopRequireDefault(_FadeInUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(_ref) {
	  var edges = _ref.data.allButterPost.edges;
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(_Head2.default, _blog.head),
	    _react2.default.createElement(
	      _FadeInUp2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'pv5 center mw7-ns' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'sans-serif' },
	          'Blog'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'ol',
	          { className: 'list pl0' },
	          edges.map(function (_ref2) {
	            var _ref2$node = _ref2.node,
	                slug = _ref2$node.slug,
	                title = _ref2$node.title,
	                summary = _ref2$node.summary,
	                published = _ref2$node.published;
	
	            var datetime = new Date(published);
	            var DD = datetime.getDate();
	            var MM = datetime.getMonth();
	            var MMMM = _monthNames2.default[MM];
	            var YYYY = datetime.getFullYear();
	            return _react2.default.createElement(
	              'li',
	              { key: slug },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/blog/' + slug,
	                  className: 'flex flex-row justify-between items-center link near-white hover-gold'
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pv2 mw-60' },
	                  _react2.default.createElement(
	                    'h2',
	                    { className: 'f3 mb1' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'bg-near-black lh-copy pa1 tracked-tight' },
	                      title
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'georgia dn db-ns i near-black mt2' },
	                    summary
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex flex-row nowrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'dn db-ns near-black hover-near-black tr' },
	                    '\xA0\u2015 ',
	                    DD + ' ' + MMMM + ', ' + YYYY
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'db dn-ns near-black hover-near-black tr' },
	                    '\xA0\u2015 ',
	                    DD + '/' + MM + '/' + YYYY
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlogPage;
	
	// eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-f1d5cd7d83a80ec826c3.js